import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './Editor.scss';

interface EditorProps {
  editorState: string;
  onEditorStateChange?: (value: string) => void;
  readOnly?: boolean;
  placeholder?: string;
  minHeight?: number;
  maxHeight?: number;
  resizable?: boolean;
}

const Editor = ({
  editorState,
  onEditorStateChange,
  readOnly = false,
  placeholder = '',
  minHeight = 150,
  maxHeight,
  resizable = true,
}: EditorProps) => {
  const editorId = readOnly ? 'editor-readonly' : 'editor-editable';

  const containerStyle: React.CSSProperties = {
    minHeight: `${minHeight}px`,
    ...(maxHeight ? { maxHeight: `${maxHeight}px` } : {}),
    resize: resizable && !readOnly ? 'vertical' : 'none',
    overflow: maxHeight ? 'auto' : 'hidden',
    width: '100%',
    maxWidth: '100%',
    minWidth: '100%',
  };

  return (
    <div
      className={`editor-container ${readOnly ? 'editor-container--readonly' : ''}`}
      style={containerStyle}
    >
      <ReactQuill
        theme="snow"
        id={editorId}
        className="editor-quill"
        onChange={onEditorStateChange}
        value={editorState || ''}
        modules={readOnly ? READONLY_MODULES : DEFAULT_MODULES}
        formats={SUPPORTED_FORMATS}
        readOnly={readOnly}
        placeholder={placeholder}
        bounds=".app"
      />
    </div>
  );
};

const DEFAULT_MODULES = {
  toolbar: [
    ['bold', 'italic'],
    [{ header: '1' }, { header: '2' }],
    [{ size: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
  ],
  clipboard: {
    matchVisual: false,
  },
};

const READONLY_MODULES = {
  toolbar: false,
  clipboard: {
    matchVisual: false,
  },
};

const SUPPORTED_FORMATS = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];

export default Editor;
